import Page from './Page';
import Component from 'vue-class-component';

import template from './GratuityDetail.vue.html';
import GratuityCarousel from '../common/gratuity/GratuityCarousel.vue';
import HeaderComponent from './Header.vue';
import { GratuityStaffImage } from '../common/gratuity/Types';

@Component({ template, components: { GratuityCarousel, HeaderComponent } })
export default class GratuityDetail extends Page {
    comment: string = '';
    inputAmount: string | number = '';
    minAmount: number = 10;
    maxAmount: number = this.app.gratuity.max_amount;
    singleRoom: string = '';
    selectRoomId: number = 0;

    private get storageKey(): string {
        return `Mypage:GratuityCart:${this.app.reserve?.id}:${this.app.query.staff_id}`;
    }

    get gratuityStaff(): any | null {
        const id = Number(this.app.query.staff_id);
        return this.app.gratuity.staffs.find((m) => m.id === id) ?? null;
    }

    get images(): readonly GratuityStaffImage[] {
        const item = this.gratuityStaff;
        if (!item) return [];
        return item.image_urls.map((url: string) => ({
            id: item.id,
            name: item.name,
            filepath: url,
        }));
    }

    async readStorage() {
        const itemStr = localStorage.getItem(this.storageKey);
        const item: {
            amount: number;
            comment: string;
            select_room_id: number;
        } | null = itemStr ? JSON.parse(itemStr) : null;
        if (item && item.amount > 0) {
            this.inputAmount = item.amount;
        }
        if (item && item.comment.length > 0) {
            this.comment = item.comment;
        }
        if (item && item.select_room_id > 0) {
            this.selectRoomId = item.select_room_id;
        }
    }

    async created() {
        await this.app.fetchGratuities();
        this.inputAmount = this.app.gratuity.default_amount;
        window.scroll(0, 0);
        if (this.app.reserves_rooms.length === 1) {
            this.selectRoomId = this.app.reserves_rooms[0].id;
        }
        await this.readStorage();
    }

    handleBlur() {
        let value = Number(this.inputAmount);
        if (isNaN(value)) {
            value = this.minAmount;
        }
        value = Math.round(value);
        if (value <= this.minAmount) {
            value = this.minAmount;
        } else if (value >= this.maxAmount) {
            value = this.maxAmount;
        }
        this.inputAmount = value;
    }

    addOrder() {
        if (!this.inputAmount) return;
        const serialized = JSON.stringify({
            amount: this.inputAmount,
            comment: this.comment,
            select_room_id: this.selectRoomId,
        });
        localStorage.setItem(this.storageKey, serialized);
        this.app.updateQuery({
            page: 'GratuityConfirm',
            staff_id: this.app.query.staff_id,
        });
    }
}
